(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TiendasModalController', TiendasModalController);

    TiendasModalController.$inject = ['$http','$uibModalInstance', '$state', 'datosTienda'];

    function TiendasModalController ($http, $uibModalInstance, $state, datosTienda) {
        console.log('[TIENDAS MODAL] Constructor iniciado');
        console.log('[TIENDAS MODAL] datosTienda recibido:', datosTienda);
        
        var vm = this;
        vm.cargando = false;
        vm.volver = volver;
        vm.ExportToXLSX = ExportToXLSX
        vm.markers = datosTienda;
        vm.mostrarDatos = false;
        vm.descargandoExcel = false;
        vm.fechasElegidas = datosTienda.fechasElegidas;
        vm.fotosfachada = [];

        console.log('[TIENDAS MODAL] vm.markers:', vm.markers);
        console.log('[TIENDAS MODAL] vm.markers.tiendas:', vm.markers.tiendas);
        console.log('[TIENDAS MODAL] Total tiendas:', vm.markers.tiendas ? vm.markers.tiendas.length : 0);
        
        getFotoFachada();
        function getFotoFachada(){
            console.log('[TIENDAS MODAL] getFotoFachada() iniciado');
            vm.mostrarDatos = false;
            vm.cargando = true;
            
            if (!vm.markers || !vm.markers.tiendas) {
                console.error('[TIENDAS MODAL] ERROR: No hay datos de tiendas');
                console.error('[TIENDAS MODAL] vm.markers:', vm.markers);
                vm.cargando = false;
                return;
            }
            
            var idNegocios = vm.markers.tiendas.map(function(objeto) {
                return Number(objeto.idNegocio) 
            });
            
            console.log('[TIENDAS MODAL] IDs de negocios:', idNegocios);
            console.log('[TIENDAS MODAL] Total IDs:', idNegocios.length);

            $http.post('api/mapa/negocios', idNegocios).then(function(response) {
                console.log('[TIENDAS MODAL] Respuesta de fotos recibida');
                console.log('[TIENDAS MODAL] Total fotos:', response.data ? response.data.length : 0);
                
                vm.fotosfachada = response.data;

                vm.markers.tiendas.forEach(function(tienda) {
                    vm.fotosfachada.forEach(function(foto) {
                      if (foto.IdNegocio === tienda.idNegocio) {
                        tienda.pathImage = foto.PathEvidencia;
                      }
                    });
                  });
                
                console.log('[TIENDAS MODAL] Fotos asignadas a tiendas');
                vm.cargando = false;
                vm.mostrarDatos = true;
                console.log('[TIENDAS MODAL] Datos listos para mostrar');
            }).catch(function(error) {
                console.error('[TIENDAS MODAL] ERROR al obtener fotos:', error);
                vm.cargando = false;
                vm.mostrarDatos = true; // Mostrar tiendas aunque falle las fotos
            });

            
        }


        function volver() {
            $uibModalInstance.dismiss('cancel');
            $state.go('home');
        }

        function ExportToXLSX() {
            vm.descargandoExcel = true;
            var fechas = vm.fechasElegidas;
            var idNegocios = vm.markers.tiendas.map(function(tienda) {
                return tienda.idNegocio;
              });
            
            var data = {
                "idnegocios": idNegocios,
                "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                "fechahasta": "" + vm.fechasElegidas.FechaFin,
            }

            $http.post('api/mapa/descargarXLSX', data , { responseType: 'arraybuffer' })
                .then(function (response) {
                
                const newDate = new Date();
                const date = newDate.getDate()+ "-" + (newDate.getMonth() + 1) + "-" + newDate.getFullYear();
                const file = new Blob([response.data], { type: 'text/xlsx' });
                saveAs(file,'TiendasMapa_' + date + '.xlsx');
                vm.descargandoExcel = false;
            })
            .catch(function(error) {
                console.log('Error Server', error);
              });;
        }

        function aceptarProyecto() {
            $uibModalInstance.close();
        }
    }
})();